/**
 * AtlasForge blog API client — thin wrappers around /api/blog/*.
 *
 * All calls resolve against `REACT_APP_BACKEND_URL` so preview + production
 * both work without env-per-page overrides. Errors bubble up as thrown
 * objects with a `.status` field so callers can distinguish 404s from 5xx.
 */
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

async function _fetch(path) {
  const res = await fetch(`${BASE}/api/blog${path}`);
  if (!res.ok) {
    const err = new Error(`Blog API ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function fetchBlogPosts({ category, q } = {}) {
  const params = new URLSearchParams();
  if (category && category !== "all") params.set("category", category);
  if (q) params.set("q", q);
  const suffix = params.toString() ? `?${params.toString()}` : "";
  const data = await _fetch(`/posts${suffix}`);
  return data.posts || [];
}

export async function fetchBlogCategories() {
  const data = await _fetch(`/categories`);
  return data.categories || [];
}

export async function fetchBlogPost(slug) {
  return _fetch(`/posts/${encodeURIComponent(slug)}`);
}

export async function fetchRelatedPosts(slug, limit = 3) {
  const data = await _fetch(`/posts/${encodeURIComponent(slug)}/related?limit=${limit}`);
  return data.posts || [];
}
